import { Container, Content } from './style';
import woman from '../../../images/woman.png'

export function FirstSection() {
    return (
        <Container>
            <Content>
                <div>
                    <h1>
                        A revolução do seu <br />
                        clube de compras e <br />
                        benefícios
                    </h1>
                    <p>Aqui você encontra preços baixos e cupons de desconto</p>
                </div>
               
                <img
                    src={woman}
                    alt="Mulher com megafone"
                />
            </Content>
        </Container>
    )
}
